import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCards from "../Components/ProjectCards/ProjectCards";

function Projects() {
  return (
    <Container id="projects" fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

        <Col md={6} className="project-card">
            <ProjectCards
              imgPath="/images/sports.png"
              title="Clone of Sportsjam.in"
              description="This is a typical e-commerce website clone. The flow of our website starts from a landing page then to a product page that leads to a description page which takes to cart and payment page. "
              tech="Tech-Stacks"
              techD="React | Redux | React-Router | Styled-Components | local-storage "
              link="https://cloneofsportsjamunit4.netlify.app/"
              a="https://github.com/sangamk04/Clone_of_Sportsjam.in"
            />
          </Col>

      
          <Col md={6} className="project-card">
            <ProjectCards
              imgPath="/images/dunzo.png"
              title="Clone of Dunzo.com"
              description="This Website is an Indian company that delivers groceries and essentials, fruits and vegetables, meat, pet supplies, food, and medicines in major cities."
              tech="Tech-Stacks"
              techD="Html | JavaScript | Css | Api | local-storage |"
              link="https://sparkly-cheesecake-336e1f.netlify.app/"
              a="https://github.com/sangamk04/Clone-Of-Dunzo.com-/tree/main/zunzo/Dunzo-main"
            />
          </Col>

          <Col md={6} className="project-card" >
            <ProjectCards
              imgPath="/images/style.png"
              title="Clone of Stylecraze.com"
              description="This is a global women’s platform that aims to answer one question. What do
              women want? From health and wellness to lifestyle and beauty."
              tech="Tech-Stacks"
              techD="Html | JavaScript | Css | "
              link="https://happy-feynman-648783.netlify.app/"
              a="https://github.com/sangamk04/Stylecraze-masai"
            />
          </Col>

          {/* <Col md={6} className="project-card">
            <ProjectCards
              imgPath="/images/sports.png"
              title="Clone of Sportsjam.in"
              description="This is a typical e-commerce website clone. The flow of our website starts from a landing page then to a product page that leads to a description page which takes to cart and payment page. "
              tech="Tech-Stacks"
              techD="React | Redux | React-Router | Styled-Components | local-storage "
              link="https://cloneofsportsjamunit4.netlify.app/"
              a="https://github.com/sangamk04/Clone_of_Sportsjam.in"
            />
          </Col> */}


        </Row>
      </Container>
    </Container>
  );
}
export default Projects;
